import {
  OnSaleChanges,
  OnSeeAllTravelSalesClick,
  OnSetDevice,
  OnSetMomentLocale,
  OnToggleProductsMap,
  OnWindowResize
} from './application.types'

export const SALE_CHANGES = 'SALE_CHANGES'
export const SEE_ALL_TRAVEL_SALES_CLICK = 'SEE_ALL_TRAVEL_SALES_CLICK'
export const SET_DEVICE = 'SET_DEVICE'
export const SET_MOMENT_LOCALE = 'SET_MOMENT_LOCALE'
export const TOGGLE_PRODUCTS_MAP = 'TOGGLE_PRODUCTS_MAP'
export const WINDOW_RESIZE = 'WINDOW_RESIZE'

export const onSaleChanges: OnSaleChanges = () => ({
  type: SALE_CHANGES
})

export const onSeeAllTravelSalesClick: OnSeeAllTravelSalesClick = isRedirectToNavigation => ({
  payload: { isRedirectToNavigation },
  type: SEE_ALL_TRAVEL_SALES_CLICK
})

export const onSetDevice: OnSetDevice = device => ({
  payload: { device },
  type: SET_DEVICE
})

export const onSetMomentLocale: OnSetMomentLocale = () => ({
  type: SET_MOMENT_LOCALE
})

export const onToggleProductsMap: OnToggleProductsMap = isOpen => ({
  payload: { isOpen },
  type: TOGGLE_PRODUCTS_MAP
})

export const onWindowResize: OnWindowResize = screenSize => ({
  payload: { screenSize },
  type: WINDOW_RESIZE
})
